import axios from "axios";
const CONTROLLER_PATH = "Claim";
class ClaimService {
    //CREATE
    create(claim) {
        return axios.post(CONTROLLER_PATH, claim).then((response) => response.data);
    }

    generateClaimBatch(claimId) {
        return axios.post(CONTROLLER_PATH + "/GenerateClaimBatch", null, { params: { claimId } }).then((response) => response.data);
    }
    addNote(claimId, text) {
        return axios.put(CONTROLLER_PATH + "/" + claimId + "/addNote", { text: text }).then((response) => response.data);
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getClaimPreSubmissionFormDto(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetClaimPreSubmissionFormDto" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getreducedview(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetReducedView" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getNonValidated(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetNonValidated", { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getAgeing(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/ageing", { params: urlParameters }).then((response) => response.data);
    }

    getageingmanagement(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getageingmanagement", { params: urlParameters }).then((response) => response.data);
    }

    getclaimsubmissionmanagementwidgetdto(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getclaimsubmissionmanagementwidgetdto', {params: urlParameters}).then((response) => response.data);
    }

    getPreSubmissionClaims() {
        return axios.get(CONTROLLER_PATH + "/getPreSubmissionClaims").then((response) => response.data);
    }

    getclaimpostsubmissionformdto(id, requestId, urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getclaimpostsubmissionformdto/" + id, { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getStatuses() {
        return axios.get(CONTROLLER_PATH + "/getStatuses").then((response) => response.data);
    }

    //UPDATE
    update(claim) {
        return axios.put(CONTROLLER_PATH + "/" + claim.id, claim).then((response) => response.data);
    }

    setPrintedVerified(id, isPrintedVerified) {
        return axios.post(CONTROLLER_PATH + "/SetPrintedVerified", null, { params: { id, isPrintedVerified } }).then((response) => response.data);
    }

    updateClaimPostSubmissionDetails(id, formData) {
        return axios
            .put(CONTROLLER_PATH + "/updateClaimPostSubmissionDetails/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    claimlinknumberstatusimport(form) {
        return axios
            .post(CONTROLLER_PATH + "/claimlinknumberstatusimport", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new ClaimService();
